<form class="form-vertical" name="edittrackerform" id="edittrackerform" data-hook="edittrackerform">
    <div class="row">
        <div class="form-group col-xs-12 col-md-12">
            <label for="trackername">Bezeichnung*</label>
            <input type="text" class="form-control" id="trackername" name="trackername" ng-model="vm.tracker.name" required>
        </div>
    </div>

    <div class="panel panel-info" ng-repeat="def in vm.tracker.def">
        <div class="panel-heading">
            <span class="pull-left"> Sub-Tracker {{$index}}: {{def.label}}</span>
            <span class="pull-right">
                <span class="btn btn-danger" ng-click="vm.removeDef($index)"><i class="fa fa-remove"></i></span>
            </span>
            <span class="clearfix"></span>
        </div>
        <div class="panel-body">
            <trackerdef trackerdef="def" index="$index" parentsave="vm.defsave(trackerdef, index)"></trackerdef>
        </div>
    </div>


    <div class="row">
        <div class="form-group col-xs-12 col-md-12">
            <span class="btn btn-success" ng-click="vm.addDef()">Weiteren Sub-Tracker einfügen</span>
        </div>
    </div>


    <div class=" row">
        <div class="col-xs-12">
            <div class="form-group">
                <button class="btn btn-success disabled" type="button" tabindex="9" ng-click="vm.save()"
                ng-hide="edittrackerform.trackername.$valid">Speichern</button>
                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()"
                        ng-show="edittrackerform.trackername.$valid">Speichern</button>
                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
            </div>
        </div>
    </div>
</form>